
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/nosotros",
      function () {
        return require("private-next-pages/es-co/nosotros/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/nosotros"])
      });
    }
  